import { TrustBadge } from "@/components/shared";
import { Info, TriangleAlert } from "lucide-react";

export default function BiasMonitor({ bias }) {
  if (!bias) return null;
  return (
    <div className="space-y-4 max-w-4xl" data-testid="admin-bias">
      <div className="rounded-lg border border-blue-500/30 bg-blue-500/10 p-3 flex gap-2.5">
        <Info className="h-4 w-4 text-blue-400 shrink-0 mt-0.5" />
        <p className="text-xs text-blue-200 leading-relaxed">{bias.note}</p>
      </div>
      {bias.flagged.length > 0 && (
        <div className="rounded-lg border border-amber-500/30 bg-amber-500/10 p-3 flex items-center gap-2.5" data-testid="bias-flagged">
          <TriangleAlert className="h-4 w-4 text-amber-400 shrink-0" />
          <p className="text-sm text-amber-200"><strong>{bias.flagged.length}</strong> role(s) flagged for human review: {bias.flagged.join(", ")}. Selection rate falls below the four-fifths threshold of the best-performing role.</p>
        </div>
      )}
      <div className="rounded-xl border border-border bg-card overflow-hidden">
        <div className="grid grid-cols-12 gap-2 px-4 py-2.5 text-[11px] uppercase tracking-wider text-muted-foreground border-b border-border">
          <div className="col-span-4">Role</div><div className="col-span-2 text-center">Applicants</div><div className="col-span-2 text-center">Avg score</div><div className="col-span-2 text-center">Shortlist rate</div><div className="col-span-2 text-center">Status</div>
        </div>
        {bias.rows.map((r) => (
          <div key={r.job_id} className="grid grid-cols-12 gap-2 px-4 py-3 text-sm items-center border-b border-border last:border-0" data-testid={`bias-row-${r.job_id}`}>
            <div className="col-span-4 font-medium truncate">{r.title}</div>
            <div className="col-span-2 text-center font-mono">{r.applicants}</div>
            <div className="col-span-2 text-center font-mono">{r.avg_score ?? "—"}</div>
            <div className="col-span-2 text-center font-mono">{Math.round(r.shortlist_rate * 100)}%</div>
            <div className="col-span-2 flex justify-center">{r.adverse_impact ? <TrustBadge type="flag">review</TrustBadge> : <TrustBadge type="high">ok</TrustBadge>}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
